import { Component, OnInit } from '@angular/core';
import { LiveStreamsService } from 'common-ui';
import { UserService } from 'user';
import { LiveScheduleList, LiveStream, User } from 'models';
import { Transfer, PageService, PageComponent } from 'common';
import { ApiLiveSchedule } from 'api';

@Component({
  selector: 'tyt-todays-live-schedule',
  templateUrl: './todays-live-schedule.component.html',
  styleUrls: ['./todays-live-schedule.component.scss']
})
export class TodaysLiveScheduleComponent extends PageComponent implements OnInit {

  constructor(
    private liveStreamsService: LiveStreamsService,
    private userService: UserService,
    pageService: PageService
  ) {
    super(pageService)
  }

  useTimezone : string = 'local';

  @Transfer()
  allStreams : LiveStream[];

  @Transfer()
  user : User;

  @Transfer()
  timezoneString = null;

  @Transfer()
  timezone : string = null;

  get isMember() {
    return this.user && this.user.entitled;
  }

  async init() {
    this.subscribe(this.userService.userChanged, user => this.user = user);
    this.fetchLiveSchedule();
    this.allStreams = await this.loadData(() => this.liveStreamsService.active());
  }

  async fetchLiveSchedule() {
    let options : Intl.DateTimeFormatOptions = { timeZoneName: 'short' };
    let customOffset = undefined;

    if (typeof window === 'undefined') {
      options['timeZone'] = 'America/New_York';
      customOffset = this.getTimezoneOffset(new Date(), options['timeZone']);
    }

    this.liveSchedules = await this.liveStreamsService.getSchedule(customOffset);

    let currentDay = new Date().getDay();
    this.determineUpcomingEvents();

    let date = new Date();
    this.timezoneString = date.toLocaleTimeString('en-us', options).split(' ')[2];
    if (typeof window === 'undefined' || this.useTimezone != 'local')
      this.timezone = this.timezoneString;
    else 
      this.timezone = null;

    let simpleTzMap = {
      PST: 'PT',
      PDT: 'PT',
      CST: 'CT',
      CDT: 'CT',
      MST: 'MT',
      MDT: 'MT',
      EST: 'ET',
      EDT: 'ET'
    };

    if (simpleTzMap[this.timezoneString]) {
      this.timezoneString = simpleTzMap[this.timezoneString];
    }
  }

  @Transfer()
  liveSchedules : LiveScheduleList[];

  @Transfer()
  upcomingEvents : ApiLiveSchedule[];

  determineUpcomingEvents() {
    let daysOfTheWeek = {
      'sunday': 0,
      'monday': 1,
      'tuesday': 2,
      'wednesday': 3,
      'thursday': 4,
      'friday': 5,
      'saturday': 6
    };

    let schedulesByDay : LiveScheduleList[] = [];

    for (let schedule of this.liveSchedules) {
      let index = daysOfTheWeek[schedule.day];
      schedulesByDay[index] = schedule;
    }

    let currentDay = new Date().getDay();
    
    let firstDayWithEvents = currentDay;

    for (let i = 0; i < 7; ++i) {
      let index = (firstDayWithEvents + i) % 7;
      let schedule = schedulesByDay[index];
      if (schedule && schedule.live_schedules.length > 0) {
        firstDayWithEvents = index;
        break;
      }
    }

    let nextDayWithEvents = firstDayWithEvents + 1;

    for (let i = 0; i < 7; ++i) {
      let index = (nextDayWithEvents + i) % 7;
      let schedule = schedulesByDay[index];
      if (schedule && schedule.live_schedules.length > 0) {
        nextDayWithEvents = index;
        break;
      }
    }

    let upcoming = [];
    upcoming = upcoming.concat(schedulesByDay[firstDayWithEvents].live_schedules);

    this.todayCount = upcoming.length;
    
    if (firstDayWithEvents != nextDayWithEvents)
      upcoming = upcoming.concat(schedulesByDay[nextDayWithEvents].live_schedules);

    this.upcomingEvents = upcoming;
  }

  todayCount = 0;

  limitArray(array : any[], length) {
    return array.slice(0, length);
  }

  getTimezoneOffset(d, tz) {
    var a = d.toLocaleString("ja", {timeZone: tz}).split(/[\/\s:]/);
    a[1]--;
    var t1 = Date.UTC.apply(null, a);
    var t2 = new Date(d).setMilliseconds(0);
    return (t2 - t1) / 60 / 1000 / 60;
  }

  getEventStream(event : ApiLiveSchedule): LiveStream {
    if (!this.allStreams)
      return null;

    let streams = this.allStreams.filter(x => x.active_live_event && x.active_live_event.id == event.id);
    let premiumStream = streams.filter(x => x.premium)[0];
    let publicStream = streams.filter(x => !x.premium)[0];

    if (this.user && this.user.entitled)
      return premiumStream || publicStream;

    return publicStream || premiumStream;
  }

}
